import { Box } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

export const InfoText = () => {
    const { t } = useTranslate();

    const notes = [
        "finish-note-one",
        "finish-note-two",
        "finish-note-there",
        "finish-note-four",
        "finish-note-five",
        "finish-note-six",
        "finish-note-seven",
        "finish-note-eight",
        "finish-note-nine",
        "finish-note-ten",
        "finish-note-eleven",
    ];

    return (
        <Box sx={{ p: 2, mt: 2, bgcolor: 'background.neutral', borderRadius: 1 }}>
            {notes.map((noteKey, index) => (
                <ByzMuiTypography
                    key={noteKey}
                    variant="body2"
                    sx={{
                        whiteSpace: 'pre-line',
                        mb: index === notes.length - 1 ? 0 : 1,
                        fontWeight: index === 0 ? 'bold' : 'normal'
                    }}
                >
                    {t(`nutritional-risk-score.${noteKey}`)}
                </ByzMuiTypography>
            ))}
        </Box>
    );
};

